import { StyleSheet } from 'react-native';
import { ticketColors } from '../../../../shared/theme/ticketColors'
import { spacing } from '../../../../shared/theme/spacing'
import { typography } from '../../../../shared/theme/typography';

export const empPermStyles = StyleSheet.create({
  content: {
    padding: spacing.lg,
    gap: spacing.lg,
    paddingBottom: spacing.xxl,
  },
  tabPane: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.md,
    gap: spacing.md,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing.md,
    paddingBottom: spacing.sm,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  cardHeaderLeft: {
    flex: 1,
    gap: spacing.xs,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ticketColors.gold + '25',
    marginRight: spacing.sm,
    flexShrink: 0,
  },
  avatarText: {
    fontSize: 16,
    fontWeight: '800',
    color: ticketColors.gold,
  },
  cardHeaderInfo: {
    flex: 1,
    gap: spacing.xs,
    minWidth: 0,
  },
  reactivateBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold + '40',
    backgroundColor: ticketColors.gold + '10',
  },
  reactivateBtnLabel: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '700',
  },
  revokedHint: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  cardRevoked: {
    opacity: 0.92,
  },
  errorText: {
    ...typography.caption,
    color: ticketColors.bad,
    padding: spacing.sm,
  },
  emptyState: {
    padding: spacing.xl,
    gap: spacing.md,
    alignItems: 'center',
  },
  emptyTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
  },
  emptySubtitle: {
    ...typography.body,
    color: ticketColors.ink2,
    textAlign: 'center',
  },
  matrixContainer: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 14,
    overflow: 'hidden',
  },
  matrixHeaderRow: {
    flexDirection: 'row',
    backgroundColor: ticketColors.paper,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
  },
  matrixHeaderCell: {
    flex: 1,
    paddingHorizontal: spacing.xs,
    paddingVertical: spacing.sm,
    alignItems: 'center',
    minWidth: 60,
  },
  matrixHeaderCellFirst: {
    flex: 1.5,
    alignItems: 'flex-start',
    paddingLeft: spacing.md,
  },
  matrixHeaderText: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '700',
    fontSize: 11,
  },
  matrixHeaderTextFirst: {
    color: ticketColors.ink,
    fontSize: 13,
  },
  matrixRow: {
    flexDirection: 'row',
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  matrixRowLast: {
    borderBottomWidth: 0,
  },
  matrixCell: {
    flex: 1,
    paddingHorizontal: spacing.xs,
    paddingVertical: spacing.sm,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 60,
  },
  matrixCellFirst: {
    flex: 1.5,
    alignItems: 'flex-start',
    paddingLeft: spacing.md,
  },
  matrixCellText: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
    fontSize: 13,
  },
  matrixCellSub: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontSize: 11,
  },
  matrixPermIcon: {
    width: 28,
    height: 28,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  matrixPermIconEdit: {
    backgroundColor: ticketColors.gold + '30',
  },
  matrixPermIconView: {
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  matrixPermIconNone: {
    backgroundColor: 'transparent',
  },
  matrixPermLabel: {
    ...typography.caption,
    fontSize: 10,
    fontWeight: '700',
  },
  matrixBranchSelector: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
  },
  matrixBranchSelectorLabel: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '600',
  },
  invitationActionsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  invitationCopyButton: {
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignSelf: 'flex-start',
  },
  invitationCopyButtonLabel: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '600',
  },
  invitationDangerButton: {
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.bad + '40',
    backgroundColor: ticketColors.bad + '08',
    alignSelf: 'flex-start',
  },
  invitationDangerButtonLabel: {
    ...typography.caption,
    color: ticketColors.bad,
    fontWeight: '600',
  },
  invitationCopyFeedback: {
    ...typography.caption,
    color: ticketColors.ok,
    fontSize: 11,
  },
});
